<template>
  <div>
  <ul class="program_legend">
    <li v-for="channelPackage in list" :key="channelPackage.id">
      <strong>{{ channelPackage.name }} <span v-if="!channelPackage.combination_with_thematic"> *</span></strong>
      {{ channelPackage.channel_ids.length }}
      <translate>kanálů</translate>
    </li>
  </ul>
  <p v-if="showAsterix" v-translate>
    * k balíčku nelze objednat tématické balíčky
  </p>
  </div>
</template>

<script>
export default {
  name: "ProgramStructureList",
  props:{
    list: Object,
  },
  computed:{
    showAsterix(){
      return Object.values(this.list).filter(item=>item.combination_with_thematic === false).length;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/downloads/program-structure/ProgramStructureList.vue